import { Box, ColorOptions, Loader, Spacer, Text } from '@jfs/ui-new'
import { FC } from 'react'
import * as React from 'react'
import { ConfirmAlert } from '../../comps/ConfirmAlert/ConfirmAlert'
import { CreditCard } from '../../comps/CreditCard'
import Footer from '../../comps/Footer'
import { formatAmount } from '../../utils'
import { THEME_PADDING } from '../../utils/constants'
import { staticStrings } from '../../utils/string'
import { MobileProcessing } from '../PaymentProcesseing/MobileProcessing'
import styles from './styles'
import { CardVendors } from './types'
interface TOneCardPros {
  theme?: any
  showSavedCards: boolean
  isOfferApplied: boolean
  savedCardApiStatus: string
  amount: string
  errMsg: string
  isOfferValidated: boolean
  validateOfferState: 'pending' | 'fulfilled' | 'rejected' | undefined
  applyOfferState: 'pending' | 'fulfilled' | 'rejected' | undefined
  proceedWithPayment: (data: any) => void
  showPaymentProcessModal: boolean
  setShowPaymentProcessModal: (value: boolean) => void
  showConfirmationAlert: boolean
  setConfirmationAlert: (show: boolean) => void
  lazyDeleteCardApi: (selected: string) => void
  savedCards: any
  onCardNumbChange: (cardNumber: string) => void
  onCardNumberBlur: (cardVendor: CardVendors, cardNumber: string) => void
  showAddeNew: boolean
  scheme: string
  setSelected: (id: string) => void
  setShowAddeNew: (state: boolean) => void
  updateModalDisplaying: (state: boolean) => void
  setIsSavedCardVisible: (visible: boolean) => void
  selected: string
  isSubscriptionEnabled: boolean
  cardNumFooter: React.ReactNode
  scFooter: React.ReactNode
  onCardSelected: (item: any) => void
  onCardNumberValid: (isValid: boolean) => void
  onAddNewCard?: () => void
  showSCCheckBox: boolean
}

const TOneCard: FC<TOneCardPros> = (props: TOneCardPros) => {
  const {
    theme,
    showSavedCards,
    isOfferApplied,
    savedCardApiStatus,
    amount,
    errMsg,
    isOfferValidated,
    validateOfferState,
    applyOfferState,
    proceedWithPayment,
    showPaymentProcessModal,
    setShowPaymentProcessModal,
    showConfirmationAlert,
    setConfirmationAlert,
    lazyDeleteCardApi,
    savedCards,
    onCardNumbChange,
    onCardNumberBlur,
    showAddeNew,
    scheme,
    setSelected,
    setShowAddeNew,
    updateModalDisplaying,
    setIsSavedCardVisible,
    selected,
    cardNumFooter,
    scFooter,
    onCardSelected,
    onCardNumberValid,
    onAddNewCard,
    showSCCheckBox,
  } = props

  const renderLoader = () => {
    return (
      <Box backgroundColor={theme?.bodyBgColor as ColorOptions} type={'fullFlexJustifyAlignCenter'}>
        <Loader color={theme?.brandColor as ColorOptions} />
      </Box>
    )
  }

  const Header = () => {
    return (
      <Box
        paddingHorizontal={THEME_PADDING.HORIZONTAL_PADDING}
        paddingVertical={THEME_PADDING.VERTICAL_PADDING}
        backgroundColor={theme?.bodyBgColor as ColorOptions}>
        <Text {...style.title}>TOPUP Amount</Text>
        <Text {...style.subTitle}>{`₹ ${formatAmount(amount)}`}</Text>
      </Box>
    )
  }

  const BTNFooter = () => {
    return (
      <>
        <Spacer size={24} />
        <Footer />
      </>
    )
  }

  const style = styles(theme)

  const renderContent = () => {
    return (
      <Box nativeID="showListScrollBar" {...style.superView}>
        <Box height={'100%'}>
          <CreditCard
            headerComp={<Header />}
            btnFooter={<BTNFooter />}
            savedCards={savedCards}
            onCardSelected={onCardSelected}
            errMsg={errMsg}
            errorColor={
              isOfferValidated && errMsg === staticStrings.offerApplied ? (theme.brandColor as ColorOptions) : undefined
            }
            amount={amount}
            isLoading={(validateOfferState === 'pending' || applyOfferState === 'pending') ?? false}
            onPayment={proceedWithPayment}
            isValid={!!scheme ?? false}
            onCardNumberChange={onCardNumbChange}
            onCardNumberBlur={onCardNumberBlur}
            theme={theme}
            onDelete={(id: string) => {
              setSelected(id)
              setConfirmationAlert(true)
            }}
            showAddeNew={showAddeNew}
            onModalState={(modelState: any) => {
              setShowAddeNew(modelState)
              updateModalDisplaying(modelState)
            }}
            onSaveCardVisible={setIsSavedCardVisible}
            cardNumFooter={cardNumFooter}
            scFotterComp={scFooter}
            onCardNumberValid={onCardNumberValid}
            onAddNewCard={onAddNewCard}
            showSCCheckBox={showSCCheckBox}
          />
        </Box>

        {/** New Implementation using Form Component */}

        <ConfirmAlert
          visible={showConfirmationAlert}
          subTitle="Are you sure you want to delete this card?"
          onCancelPress={() => {
            setConfirmationAlert(false)
          }}
          onOkPress={() => {
            lazyDeleteCardApi(selected)
            setConfirmationAlert(false)
          }}
        />
        {showPaymentProcessModal && (
          <MobileProcessing
            setShow={setShowPaymentProcessModal}
            show={showPaymentProcessModal}
            sendCallBackToNative={true}
          />
        )}
      </Box>
    )
  }

  const savedCardStatus =
    showSavedCards && !isOfferApplied && (savedCardApiStatus === 'initial' || savedCardApiStatus === 'pending')
  console.log('&&&&&&& savedCardStatus: ', savedCardStatus)

  return savedCardStatus ? renderLoader() : renderContent()
}

export default TOneCard
